import React from 'react';

import { Text } from '@betterment/samba-react';

interface Props {
  rate: string;
}

const SimpleAdvisoryFee: React.FC<Props> = ({ rate }) => {
  return (
    <>
      <Text
        css={{
          color: 'text',
          fontWeight: 'bold',
        }}
      >
        Annual advisory fee:
      </Text>
      <Text css={{ color: 'text.weak' }}> {rate}</Text>
    </>
  );
};

export default SimpleAdvisoryFee;
